export const Homepage = [
   { name: 'description', content: 'Your Travel Booking deals,Best Travel Agency on tour Packages, Book Hotels,Flights,Car & Activities.Book your perfect holiday package in the world' },
   { name: 'twitter:description', content: 'Your Travel Booking deals,Best Travel Agency on tour Packages, Book Hotels,Flights,Car & Activities.Book your perfect holiday package in the world' },
];

export const Flights = [
   {
      data: {
         title: "Online Flight Tickets Booking at Lowest Airfare – YourTravelBooking", 
         url: `https://www.yourtravelbooking.com/home/flight`,
         description: 'Book Online Flight Tickets at Lowest Airfare with Yourtravelbooking. Here you can find the cheapest airfares, compare prices and book your flight tickets online with us to save money.'
      }
   },
   { name: 'description', content: 'Book Online Flight Tickets at Lowest Airfare with Yourtravelbooking. Here you can find the cheapest airfares, compare prices and book your flight tickets online with us to save money.'},
   { name: 'twitter:description', content: 'Book Online Flight Tickets at Lowest Airfare with Yourtravelbooking. Here you can find the cheapest airfares, compare prices and book your flight tickets online with us to save money.' },
];

export const Hotels = [
   {
      data: {
         title: 'Book Hotels - Deals and Discounts Online | YourTravelBooking',
         url: `https://www.yourtravelbooking.com/home/hotel`,
         description: 'Book hotels online at best price from yourtravelbooking.com. Find amazing offers and deals on hotel bookings – Lowest price guarantee. Book now!'
      }
   },
   { name: 'description', content: 'Book hotels online at best price from yourtravelbooking.com. Find amazing offers and deals on hotel bookings – Lowest price guarantee. Book now!' },
   { name: 'twitter:description', content: 'Book hotels online at best price from yourtravelbooking.com. Find amazing offers and deals on hotel bookings – Lowest price guarantee. Book now!' },
];

export const Cars = [
   {
      data: {
         title: 'Find Cheap Car Rentals Deals | Car Hire Deals – YourTravelBooking',
         url: `https://www.yourtravelbooking.com/home/car`,
         description: 'Find cheap car hire deals and car rental deals with YourTravelBooking. Compare car hire with Enjoy, a car for every budget, with no hidden extras and a fair fuel policy as standard.'
      }
   },
   { name: 'description', content: 'Find cheap car hire deals and car rental deals with YourTravelBooking. Compare car hire with Enjoy, a car for every budget, with no hidden extras and a fair fuel policy as standard.' },
   { name: 'twitter:description', content: 'Find cheap car hire deals and car rental deals with YourTravelBooking. Compare car hire with Enjoy, a car for every budget, with no hidden extras and a fair fuel policy as standard.' },
];

export const Activities = [
   {
      data: {
         title: 'Best Vacation Places in the World | Fun Activities Nearby - Yourtravelbooking',
         url: `https://www.yourtravelbooking.com/home/activities`,
         description: 'If you are looking for a truly unique family vacation destination, then definitely consider Yourtravelbooking. We help you find and book the best things to do, fun activities, and attractions wherever you happen to be.'
      }
   },
   { name: 'description', content: 'If you are looking for a truly unique family vacation destination, then definitely consider Yourtravelbooking. We help you find and book the best things to do, fun activities, and attractions wherever you happen to be.' },
   { name: 'twitter:description', content: 'If you are looking for a truly unique family vacation destination, then definitely consider Yourtravelbooking. We help you find and book the best things to do, fun activities, and attractions wherever you happen to be.' },
];

export const HotelSearch = [
   { name: 'description', content: 'Select Hotels in ${country} and book online at Yourtravelbooking.com. Get best deals on Hotel bookings. 100% Low fares guaranteed on hotel bookings' },
   { name: 'twitter:description', content: 'Select Hotels in ${country} and book online at Yourtravelbooking.com. Get best deals on Hotel bookings. 100% Low fares guaranteed on hotel bookings' },
];

export const HotelDetails = [
   { name: 'description', content: 'Book a room in ${name} at Yourtravelbooking.com. Get best deals on hotel bookings online. 100% Low fares guaranteed on hotel bookings' },
   { name: 'twitter:description', content: 'Book a room in ${name} at Yourtravelbooking.com. Get best deals on hotel bookings online. 100% Low fares guaranteed on hotel bookings' }
];

export const HotelTravellInfo = [
   { name: 'description', content: 'Fill in the customer details and book a room in hotel online at yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Fill in the customer details and book a room in hotel online at yourtravelbooking.com' }
];

export const HotelPayment = [
   { name: 'description', content: 'Make safe and hassel free hotel booking payment online at yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Make safe and hassel free hotel booking payment online at yourtravelbooking.com' },
];

export const HotelVoucher = [
   { name: 'description', content: 'Thank you for booking at Yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Thank you for booking at Yourtravelbooking.com' },
];

export const FlightSearch = [
   { name: 'description', content: '${from} to ${to} flight bookings online at Yourtravelbooking.com. Get best deals on Roundtrips. 100% Low fares guaranteed on all flight bookings' },
   { name: 'twitter:description', content: '${from} to ${to} flight bookings online at Yourtravelbooking.com. Get best deals on Roundtrips. 100% Low fares guaranteed on all flight bookings' }
];


export const FlightDetails = [
   { name: 'description', content: '${detailsText}' },
   { name: 'twitter:description', content: '${detailsText}' }
];


export const FlightBook = [
   { name: 'description', content: 'Flight Details | Ppassenger Information | YourTravelBooking' },
   { name: 'twitter:description', content: 'Flight Details | Ppassenger Information | YourTravelBooking' }
]

export const FlightsBook = [
   { name: 'description', content: 'Fill in the customer details and book your flight online at yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Fill in the customer details and book your flight online at yourtravelbooking.com' },
];

export const FlightVoucher = [
   { name: 'description', content: 'Thank you for booking at Yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Thank you for booking at Yourtravelbooking.com' },
];

export const CarSearch = [
   { name: 'description', content: '${source} to ${destination} cab bookings online at Yourtravelbooking.com. Get best deals on Roundtrips. 100% Low fares guaranteed on all cab bookings' },
   { name: 'twitter:description', content: '${source} to ${destination} cab bookings online at Yourtravelbooking.com. Get best deals on Roundtrips. 100% Low fares guaranteed on all cab bookings' },
];

export const CarDetails = [
   { name: 'description', content: 'Book ${name} Car at Yourtravelbooking.com. Get best deals on Car bookings online. 100% Low fares guaranteed on Car bookings' },
   { name: 'twitter:description', content: 'Book ${name} Car at Yourtravelbooking.com. Get best deals on Car bookings online. 100% Low fares guaranteed on Car bookings' },
];

export const CarPayment = [
   { name: 'description', content: 'Make safe and hassel free cab booking payment online at Yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Make safe and hassel free cab booking payment online at Yourtravelbooking.com' },
];

export const CarVoucher = [
   { name: 'description', content: 'Thank you for booking at Yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Thank you for booking at Yourtravelbooking.com' },
];

export const Feedback = [
   { name: 'description', content: 'Your Travel Booking Feedback Lets Customers Signin And Rate Their Overall Experiences Of Hotel Stay, Flight Bookings And Car Booking Online' },
   { name: 'twitter:description', content: 'Have some Feedback for us? Drop us a note. We appreciate your valuable feedback, it helps us to serve you better.' },
];

export const GeneralInquiry = [
   { name: 'description', content: 'Get 100% verified phone and email enquiry, Corporate and Business Travel Enquiry, Leisure Enquiry and email verified general enquiry 24/7 on our Your Travel Booking website.' },
   { name: 'twitter:description', content: 'Get 100% verified phone and email enquiry, Corporate and Business Travel Enquiry, Leisure Enquiry and email verified general enquiry 24/7 on our Your Travel Booking website.' },

];

export const CookiePolicy = [
   { name: 'description', content: 'Get 100% verified phone and email enquiry, Corporate and Business Travel Enquiry, Leisure Enquiry and email verified general enquiry 24/7 on our Your Travel Booking website.' },
   { name: 'twitter:description', content: 'Get 100% verified phone and email enquiry, Corporate and Business Travel Enquiry, Leisure Enquiry and email verified general enquiry 24/7 on our Your Travel Booking website.' },

];

export const ContactUs = [
   { name: 'description', content: 'Dial toll-free number(+1-703-975-8756) to contact us. Our team of travel experts will be there to guide you 24/7 and answer your queries.' },
   { name: 'twitter:description', content: 'Dial toll-free number(+1-703-975-8756) to contact us. Our team of travel experts will be there to guide you 24/7 and answer your queries.' },
];

export const TermsAndConditions = [
   { name: 'description', content: 'Your Travel Booking Website Outlines The Terms And Conditions Under Which We Provide Our Online Service To You' },
   { name: 'twitter:description', content: 'Please read the terms & conditions of the policy, tariff details, cancellation & refund policy etc for Flights/Car/Hotel/Activites before booking online.' },
];

export const PrivacyPolicy = [
   { name: 'description', content: 'Your Travel Booking Is Committed To Ensuring That We Keep The Information That You Share With Us When You Use This Website As Securely As Possible' },
   { name: 'twitter:description', content: 'Find Your Travel Booking corporate privacy policy regarding users. Your Travel Booking is committed to protecting your Personal Information that you share with us' },
];

export const CovidPolicy = [
   { name: 'description', content: 'Your Travel Booking Is Committed To Ensuring That We Keep The Information That You Share With Us When You Use This Website As Securely As Possible' },
   { name: 'twitter:description', content: 'Find Your Travel Booking corporate covid policy regarding users. Your Travel Booking is committed to protecting your Personal Information that you share with us' },
];

export const RefundPolicy = [
   { name: 'description', content: 'Your Travel Booking Cancellation Charges Will Be Deducted From The Refund Amount, Before The Refund Is Made' },
   { name: 'twitter:description', content: 'In the event of refund amount will be credited to the beneficiary account within 3 to 60 working days.' },
];

export const CancellationPolicy = [
   { name: 'description', content: 'Your Travel Booking Cancellation Policy Are Subject To Cancellation Penalty Levied By The Airlines' },
   { name: 'twitter:description', content: 'In case of cancellation, client is obliged to pay the charges levied by the supplier. "YTB" is not responsible for the decisions made by the supplier.' },
];

export const AboutUs = [
   { name: 'description', content: 'YTB Was founded in 2016 by and has its office in Jacksonville FL, YTB is primarily servicing in North America, UK, and South East Asia.' },
   { name: 'twitter:description', content: 'YTB Was founded in 2016 by and has its office in Jacksonville FL, YTB is primarily servicing in North America, UK, and South East Asia.' },
];

export const Services = [
   { name: 'description', content: 'YTB offers our services are Corporate Travel Planning, Private & Customised Tour,  Travel Visa Application, Worldwide Hotel, Flight, Car Booking.' },
   { name: 'twitter:description', content: 'YTB offers our services are Corporate Travel Planning, Private & Customised Tour,  Travel Visa Application, Worldwide Hotel, Flight, Car Booking.' },
];

export const PrintItinerary = [
   { name: 'description', content: 'Enter Your Booking Number And Print The Itinerary At Yourtravelbooking.Com/print-itinerary' },
   { name: 'twitter:description', content: 'For travel bookings related to flights, hotels and cars click on to "Your Travel Booking" page and get your Print Itinerary schedule.' }
];

export const FlightScheduleChange = [
   { name: 'description', content: 'We are writing to inform you of a change to your upcoming flight booking. Please take a moment to review the details below of your original flight and the updated schedule. We apologize for any inconvenience this may cause and understand that this change may affect your travel plans. Should you need assistance or have any questions, please feel free to contact our support team support@yourtravelbooking.com or visit Contact Us page. We are here to assist you with any adjustments or concerns. Thank you for choosing Your Travel Booking, and we look forward to making your journey smooth and enjoyable.' },
   { name: 'twitter:description', content: 'We are writing to inform you of a change to your upcoming flight booking. Please take a moment to review the details below of your original flight and the updated schedule. We apologize for any inconvenience this may cause and understand that this change may affect your travel plans. Should you need assistance or have any questions, please feel free to contact our support team support@yourtravelbooking.com or visit Contact Us page. We are here to assist you with any adjustments or concerns. Thank you for choosing Your Travel Booking, and we look forward to making your journey smooth and enjoyable.' }
];


export const ChatUs = [
   { name: 'description', content: 'We are always there to answer your queries. Chat with our team of experts from the decision center to find the right destination point.' },
   { name: 'twitter:description', content: 'We are always there to answer your queries. Chat with our team of experts from the decision center to find the right destination point.' },
];

export const SocialNetworking = [
   { name: 'description', content: 'Connect us on Social Net Working sites - Facebook, Twitter, Linkedin, Pinterest, Instagram and Tumblr.' },
   { name: 'twitter:description', content: 'Connect us on Social Net Working sites - Facebook, Twitter, Linkedin, Pinterest, Instagram and Tumblr.' }
];

export const SignUp = [
   { name: 'description', content: 'Sign Up For Yourtravelbooking.Com And Get Best Deals On Hotels, Flight Tickets, Cars And Activities Online' },
   { name: 'twitter:description', content: 'Create Your Travel Booking Account. Enjoy Faster Checkouts For Flight, Hotel, and Car booking. Sign up  takes less than 10 seconds.' }
];

export const Login = [
   { name: 'description', content: 'Welcome to Your Travel Booking Website! For your security, you will always be asked to log in to your YTB account.' },
   { name: 'twitter:description', content: 'Welcome to Your Travel Booking Website! For your security, you will always be asked to log in to your YTB account.' }
];

export const Logout = [
   { name: 'description', content: 'You have successfully logged out! Thank you for choosing the YTB website for your vacation. For your security, we recommend you clear your browser cache after.' },
   { name: 'twitter:description', content: 'You have successfully logged out! Thank you for choosing the YTB website for your vacation. For your security, we recommend you clear your browser cache after.' }
];

export const ChangePassword = [
   { name: 'description', content: 'Changing your YTB account password can help keep your account safe. Here is how to do it on desktop or mobile, even if you forgot your current YTB account.' },
   { name: 'twitter:description', content: 'Changing your YTB account password can help keep your account safe. Here is how to do it on desktop or mobile, even if you forgot your current YTB account.' }
];

export const Profile = [
   { name: 'description', content: 'Customer View Profile page on YTB. View all information about your Flight, Hotel or Car bookings and Cancellations.' },
   { name: 'twitter:description', content: 'Customer View Profile page on YTB. View all information about your Flight, Hotel or Car bookings and Cancellations.' }
];

export const FlightService = [
   { name: 'description', content: 'You can search for all international and domestic airlines and flight Services and Baggage Policy information.' },
   { name: 'twitter:description', content: 'You can search for all international and domestic airlines and flight Services and Baggage Policy information.' }
];


export const ActivitySearch = [
   { name: 'description', content: 'Select Sight seeing tours and activities in ${country} and book online at Yourtravelbooking.com. Get best deals on Sight seeing tours and activities bookings. 100% Low fares guaranteed on sight sering tours and activities bookings' },
   { name: 'twitter:description', content: 'Select Sight seeing tours and activities in ${country} and book online at Yourtravelbooking.com. Get best deals on Sight seeing tours and activities bookings. 100% Low fares guaranteed on sight sering tours and activities bookings' },
];

export const ActivityDetails = [
   { name: 'description', content: 'Book a sight seeing tour and activities in ${name} at Yourtravelbooking.com. Get best deals on sight seeing tours and activities bookings online. 100% Low fares guaranteed on sight seeing tours and activities bookings' },
   { name: 'twitter:description', content: 'Book a sight seeing tour and activities in ${name} at Yourtravelbooking.com. Get best deals on sight seeing tours and activities bookings online. 100% Low fares guaranteed on sight seeing tours and activities bookings' }
];

export const ActivityTravellInfo = [
   { name: 'description', content: 'Fill in the customer details and book a sight seeing tour and activity online at yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Fill in the customer details and book a sight seeing tour and activity online at yourtravelbooking.com' },
];

export const ActivityPayment = [
   { name: 'description', content: 'Make safe and hassel free sight seeing tour and activity booking payment online at Yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Make safe and hassel free cab booking payment online at Yourtravelbooking.com' },
];

export const ActivityVoucher = [
   { name: 'description', content: 'Thank you for booking at Yourtravelbooking.com' },
   { name: 'twitter:description', content: 'Thank you for booking at Yourtravelbooking.com' },
];

export const Canonical_URL = {
   PrintItinery: '/print-itinerary',
   termsandcond: '/terms-and-conditions',
   feedback: '/feedback',
   aboutus: '/about-us',
   refund: '/refund',
   cancellation: '/cancellation',
   ourservices: '/our-services',
   privacypolicy: '/privacy-policy',
   covidpolicy: '/covid-policy',
   signup: '/signup',
   hotel: '/home/hotel',
   flight: '/home/flight',
   car: '/home/car',
   activities: '/home/activities',
   flightservice: '/flight-service',
   help: '/help'
};

export const FlightLP = [
   { name: 'description', content: 'Book Flights Tickets for {from} to {to} online at best price from yourtravelbooking.com. Find amazing offers and deals on flight bookings – Lowest price guarantee. Book now!' },
   { name: 'twitter:description', content: 'Book Flights Tickets for {from} to {to} online at best price from yourtravelbooking.com. Find amazing offers and deals on flight bookings – Lowest price guarantee. Book now!' },
];

export const HotelLP = [
   { name: 'description', content: 'Book hotels in {from} online at best price from yourtravelbooking.com. Find amazing offers and deals on hotel bookings – Lowest price guarantee. Book now!' },
   { name: 'twitter:description', content: 'Book hotels in {from} online at best price from yourtravelbooking.com. Find amazing offers and deals on hotel bookings – Lowest price guarantee. Book now!' },
];

export const CarLP = [
   { name: 'description', content: 'Book cabs in {from} online at best price from yourtravelbooking.com. Find amazing offers and deals on cab bookings – Lowest price guarantee. Book now!' },
   { name: 'twitter:description', content: 'Book cabs in {from} online at best price from yourtravelbooking.com. Find amazing offers and deals on cab bookings – Lowest price guarantee. Book now' },
];

export const ActivitiesLP = [
   { name: 'description', content: 'Book sight seeing tours and activities in {from} online at best price from yourtravelbooking.com. Find amazing offers and deals on sight seeing tours and activities bookings – Lowest price guarantee. Book now!' },
   { name: 'twitter:description', content: 'Book sight seeing tours and activities in {from} online at best price from yourtravelbooking.com. Find amazing offers and deals on sight seeing tours and activities bookings – Lowest price guarantee. Book now!' },
];




export const CouponsPage = [
   { name: 'description', content: 'Your Travel Booking provides best Deals to user by creating coupons. Use {couponCode} for your next {module} booking from {fromDate} to {toDate} from {country} to get benefits of Coupon and Refer to your friends' },
   { name: 'twitter:description', content: 'Your Travel Booking provides best Deals to user by creating coupons. Use {couponCode} for your next {module} booking from {fromDate} to {toDate} from {country} to get benefits of Coupon and Refer to your friends' },
];



export const CouponsInformationPage = [
   {
      data: {
         title: "All Coupons ${Information} - Your Travel Booking", url: `https://www.yourtravelbooking.com/home/flight`,
         description: 'Your Travel Booking provides ${Information} about best Deals to user by creating coupons. To get benefits of Coupon and Refer to your friends'
      }
   },
   { name: 'description', content: 'Your Travel Booking  provides ${Information} about best Deals to user by creating coupons. To get benefits of Coupon and Refer to your friends' },
   { name: 'twitter:description', content: 'Your Travel Booking provides ${Information} about best Deals to user by creating coupons. To get benefits of Coupon and Refer to your friends' },
];


export const CorporateTravelPlanningPage = [
   { name: 'description', content: 'Your Travel Booking provides best corporate travel planning' },
   { name: 'twitter:description', content: 'Your Travel Booking provides best corporate travel planning' },
];



export const WorldWideAirTicketingPage = [
   { name: 'description', content: 'Your Travel Booking provides best World wide air ticketing' },
   { name: 'twitter:description', content: 'Your Travel Booking provides best World wide air ticketing' },
];

export const EmailValidation = [
   { name: 'description', content: 'Validating your Email Address At Yourtravelbooking.Com' },
   { name: 'twitter:description', content: 'Validating your Email Address At Yourtravelbooking.Com' },
];

export const EmailUnSubscribe = [
   { name: 'description', content: 'Un subscribing to Notifications At Yourtravelbooking.Com' },
   { name: 'twitter:description', content: 'Un subscribing to Notifications At Yourtravelbooking.Com' },
];

export const ErrorPage = [
   { name: 'description', content: 'Your Travel Booking- Contact Us for support on your booking' },
   { name: 'twitter:description', content: 'Your Travel Booking- Contact Us for support on your booking' },
];

export const ExternalPayment = [
   { name: 'description', content: 'Make Payment for Booking Additional Support - Your Travel Booking' },
   { name: 'twitter:description', content: 'Make Payment for Booking Additional Support - Your Travel Booking' },
];

